import "./dialog.scss";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "", 
  message = "¿Estás seguro?", 
  confirmText = "Confirmar", 
  cancelText = "Cancelar" 
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="dialog">
      <DialogTitle className="dialog-title">
        <span className="dialog-warning-icon">❔</span> {title}
      </DialogTitle>
      <DialogContent className="dialog-content">{message}</DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="outlined" color="primary">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
